'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import AppLogo from '@/components/ui/AppLogo';
import { ChevronDown } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

export default function Slide01Cover({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0f2318]">
      {/* Background gradient layers */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1586748241215-9d59fb5b6cd6"
          alt="Phong cảnh hồ Trị An nhìn từ trên cao, mặt nước xanh bao quanh bởi rừng nhiệt đới"
          className="w-full h-full object-cover opacity-12" />

        <div className="absolute inset-0 bg-gradient-to-br from-[#1a3a2a]/90 via-[#0f2318]/95 to-[#0a1a0f]/95" />
        <div className="absolute top-0 left-0 right-0 h-[60%] bg-gradient-to-b from-[rgba(76,175,125,0.08)] to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-[40%] bg-gradient-to-t from-[rgba(232,160,48,0.05)] to-transparent" />

        {/* Decorative circles */}
        <div className="absolute -top-32 -right-32 w-[600px] h-[600px] rounded-full bg-[rgba(76,175,125,0.04)] blur-3xl" />
        <div className="absolute -bottom-48 -left-48 w-[700px] h-[700px] rounded-full bg-[rgba(232,160,48,0.03)] blur-3xl" />

        {/* Grid pattern */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: 'linear-gradient(rgba(76,175,125,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(76,175,125,0.5) 1px, transparent 1px)',
            backgroundSize: '60px 60px'
          }} />


        {/* Large leaf shapes */}
        <svg className="absolute top-[10%] right-[5%] opacity-[0.06] w-[400px] h-[400px]" viewBox="0 0 200 200" fill="none">
          <ellipse cx="100" cy="100" rx="40" ry="90" fill="#4caf7d" transform="rotate(-30 100 100)" />
        </svg>
        <svg className="absolute bottom-[15%] left-[3%] opacity-[0.05] w-[300px] h-[300px]" viewBox="0 0 200 200" fill="none">
          <ellipse cx="100" cy="100" rx="35" ry="80" fill="#a8d87a" transform="rotate(20 100 100)" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6 text-center">
        <div className="fade-in-up" style={{ transitionDelay: '0.1s' }}>
          <div className="flex items-center justify-center gap-3 mb-8">
            <AppLogo size={48} />
            <span className="font-display text-[18px] font-600 text-[#a0b8a8] tracking-widest uppercase">
              Tri An Green Travel
            </span>
          </div>
        </div>

        <div className="fade-in-up" style={{ transitionDelay: '0.2s' }}>
          <div className="chapter-badge mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-[#4caf7d] inline-block" />
            Volunteer Camp Program
          </div>
        </div>

        <div className="fade-in-up max-w-4xl" style={{ transitionDelay: '0.3s' }}>
          <h1 className="font-display font-900 text-[clamp(36px,6vw,80px)] leading-[1.05] text-[#f0ede6] tracking-tight mb-2">
            TRI AN GREEN
          </h1>
          <h1 className="font-display font-900 text-[clamp(36px,6vw,80px)] leading-[1.05] tracking-tight mb-8">
            <span className="text-gradient-green" suppressHydrationWarning>VOLUNTEER</span>{' '}
            <span className="text-gradient-amber" suppressHydrationWarning>CAMP</span>
          </h1>
        </div>

        <div className="fade-in-up" style={{ transitionDelay: '0.45s' }}>
          <div className="section-divider mx-auto mb-8" />
        </div>

        <div className="fade-in-up max-w-2xl" style={{ transitionDelay: '0.55s' }}>
          <p className="font-body text-[clamp(16px,2.2vw,22px)] text-[#a0b8a8] leading-relaxed font-300">Mỗi chuyến đi là 1 hành trình đáng nhớ

          </p>
          <p className="font-display text-[clamp(18px,2.5vw,26px)] font-600 text-[#f0ede6] mt-1">Cơ hội trở thành Gương Mặt Đại Diện Hệ Sinh Thái Tri An

          </p>
        </div>

        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce opacity-40">
          <ChevronDown size={28} className="text-[#4caf7d]" />
        </div>
      </div>
    </SlideWrapper>);

}